import CheckIcon from '@mui/icons-material/Check';
import EditableLable from '../labels/EditableLabel/EditableLable';
import OutlinedCheckBox from '../Form/OutlinedCheckBox/OutlinedCheckBox';
import colors from '../../../scss/colors';
import classes from './MonthCalendar.module.scss';
import { submissionEnum } from '../../../utils/enums';

const shortDays = ['M', 'T', 'W', 'T', 'F', 'S', 'S'];

const CalendarItem = (props) => {
  const { date, value, changeHandler, disabled } = props;

  return (
    <div className={`${classes.itemContainer} ${disabled ? classes.disabled : ''}`}>
      <p className={classes.date}>{date}</p>
      {typeof value !== 'boolean' && (
        <EditableLable value={value !== 0 ? value : ''} changeHandler={changeHandler} disabled={disabled} />
      )}
      {typeof value === 'boolean' && disabled && value && (
        <CheckIcon sx={{ fontSize: '28px', color: colors.PRIMARY_BLUE }} />
      )}
      {typeof value === 'boolean' && !disabled && (
        <OutlinedCheckBox value={value} onChange={changeHandler} size="28px" />
      )}
    </div>
  );
};

const MonthCalendar = (props) => {
  const {
    data,
    dateProperty,
    changeHandler = () => {},
    valueProperty,
    monthIndex,
    disabled = false,
    timesheetType
  } = props;

  const firstDayOfMonth = new Date(data?.[0]?.[dateProperty]);
  const startDayOfWeek = firstDayOfMonth.getDay();

  const blankDays = Array.from({ length: startDayOfWeek === 0 ? 6 : startDayOfWeek - 1 }, (_, i) => (
    <p key={`blank-${i}`}>&nbsp;</p>
  ));

  return (
    <section className={classes.wrapper}>
      {shortDays?.map((dayName, index) => (
        // eslint-disable-next-line react/no-array-index-key -- initials repeat (T, S); static list
        <p key={index} className={classes.dayTitle}>
          {dayName}
        </p>
      ))}
      {blankDays}
      {timesheetType === submissionEnum.BI_WEEKLY
        ? data?.map((item) => {
            return (
              <CalendarItem
                key={item[dateProperty]}
                date={new Date(item[dateProperty]).getDate()}
                value={item[valueProperty]}
                disabled={disabled}
                changeHandler={(newValue) => changeHandler(item[dateProperty], newValue)}
              />
            );
          })
        : data?.map((item) =>
            new Date(item[dateProperty]).getMonth() === monthIndex ? (
              <CalendarItem
                key={item[dateProperty]}
                date={new Date(item[dateProperty]).getDate()}
                value={item[valueProperty]}
                disabled={disabled}
                changeHandler={(newValue) => changeHandler(item[dateProperty], newValue)}
              />
            ) : (
              <p key={item[dateProperty]}>&nbsp;</p>
            )
          )}
    </section>
  );
};

export default MonthCalendar;
